import { darkMode, reducedMotion } from "./dark.js";

const margin = 10;

export default function blobSvg(
	isInRegion,
	{ x, y },
	colour,
	stroke
) {
	const top = isInRegion(x, y - 1),
		bottom = isInRegion(x, y + 1),
		left = isInRegion(x - 1, y),
		right = isInRegion(x + 1, y);

	const path = [];

	// start in top left
	if (top) path.push(`M ${left ? -margin : margin} ${-margin}`);
	else path.push(`M ${left ? -margin : margin * 2} ${margin}`);

	// draw top edge and top right corner
	if (top && right && !isInRegion(x + 1, y - 1)) path.push(
		`L ${100 - margin} ${-margin}`,
		`L ${100 - margin} 0`,
		`A ${margin} ${margin} 0 0 0 100 ${margin}`,
		`L ${100 + margin} ${margin}`,
	);
	else if (right) path.push(`L ${100 + margin} ${top ? -margin : margin}`);
	else if (top) path.push(`L ${100 - margin} ${-margin}`);
	else path.push(
		`L ${100 - margin * 2} ${margin}`,
		`A ${margin} ${margin} 0 0 1 ${100 - margin} ${margin * 2}`
	);

	// draw right edge and bottom right corner
	if (bottom && right && !isInRegion(x + 1, y + 1)) path.push(
		`L ${100 + margin} ${100 - margin}`,
		`L 100 ${100 - margin}`,
		`A ${margin} ${margin} 0 0 0 ${100 - margin} 100`,
		`L ${100 - margin} ${100 + margin}`,
	);
	else if (bottom) path.push(`L ${right ? 100 + margin : 100 - margin} ${100 + margin}`);
	else if (right) path.push(`L ${100 + margin} ${100 - margin}`);
	else path.push(
		`L ${100 - margin} ${100 - margin * 2}`,
		`A ${margin} ${margin} 0 0 1 ${100 - margin * 2} ${100 - margin}`
	);

	// draw bottom edge and bottom left corner
	if (bottom && left && !isInRegion(x - 1, y + 1)) path.push(
		`L ${margin} ${100 + margin}`,
		`L ${margin} 100`,
		`A ${margin} ${margin} 0 0 0 0 ${100 - margin}`,
		`L ${-margin} ${100 - margin}`,
	);
	else if (left) path.push(`L ${-margin} ${bottom ? 100 + margin : 100 - margin}`);
	else if (bottom) path.push(`L ${margin} ${100 + margin}`);
	else path.push(
		`L ${margin * 2} ${100 - margin}`,
		`A ${margin} ${margin} 0 0 1 ${margin} ${100 - margin * 2}`
	);

	// draw left edge and top left corner
	if (top && left && !isInRegion(x - 1, y - 1)) path.push(
		`L ${-margin} ${margin}`,
		`L 0 ${margin}`,
		`A ${margin} ${margin} 0 0 0 ${margin} 0`,
		`L ${margin} ${-margin}`,
	);
	else if (top || left) path.push(`Z`);
	else path.push(
		`L ${margin} ${margin * 2}`,
		`A ${margin} ${margin} 0 0 1 ${margin * 2} ${margin}`
	);

	const svg = `<svg viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
		<g stroke="none" fill="${darkMode.active ? '#000000' : '#ffffff'}" fill-rule="evenodd">
			<rect x="-5" y="-5" width="110" height="110"></rect>
		</g>
		<path
			${stroke ? `stroke="${stroke}" stroke-width="8"` : 'stroke="none"'}
			fill="${colour}" fill-rule="evenodd"
			d="${path.join(' ')}"
		/>
	</svg>`;
	return {
		url: `url('data:image/svg+xml,${encodeURIComponent(svg)}')`,
		colour
	};
}
